import { hasSpecialChars } from "../app-consts/appConstants";

export const validateVin = (vin: string): boolean => !hasSpecialChars.test(vin) && vin?.length === 17;